import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Person from "@/shared/model/person";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import SogIcon from "@/shared/ui/SogIcon.vue";

interface Props {
  person?:Person
}

export default /*@__PURE__*/_defineComponent({
  __name: 'PersonCardComponent',
  props: {
    person: { default: undefined }
  },
  setup(__props: any) {

const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, { class: "sog-card" }, {
    default: _withCtx(() => [
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createElementVNode("table", null, [
            _createElementVNode("tr", null, [
              _cache[0] || (_cache[0] = _createElementVNode("td", null, " Typ ", -1)),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(SogIcon, { icon: "mdi-account" }),
                  _createVNode(SogDataLabel, { value: "Natürliche Person" })
                ], 512), [
                  [_vShow, props.person.personType==='Natural']
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(SogIcon, { icon: "mdi-office-building" }),
                  _createVNode(SogDataLabel, { value: "Juristische Person" })
                ], 512), [
                  [_vShow, props.person.personType==='Legal']
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("tr", null, [
              _cache[1] || (_cache[1] = _createElementVNode("td", null, " Vorname ", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: props.person.name2
                }, null, 8, ["value"])
              ])
            ], 512), [
              [_vShow, props.person.personType==='Natural']
            ]),
            _withDirectives(_createElementVNode("tr", null, [
              _cache[2] || (_cache[2] = _createElementVNode("td", null, " Nachname ", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: props.person.name1
                }, null, 8, ["value"])
              ])
            ], 512), [
              [_vShow, props.person.personType==='Natural']
            ]),
            _withDirectives(_createElementVNode("tr", null, [
              _cache[3] || (_cache[3] = _createElementVNode("td", null, " Firma ", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: props.person.name1
                }, null, 8, ["value"])
              ])
            ], 512), [
              [_vShow, props.person.personType==='Legal']
            ]),
            _withDirectives(_createElementVNode("tr", null, [
              _cache[4] || (_cache[4] = _createElementVNode("td", null, " Firmenzusatz ", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: props.person.name2
                }, null, 8, ["value"])
              ])
            ], 512), [
              [_vShow, props.person.personType==='Legal']
            ])
          ])
        ]),
        _: 1
      }),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})